import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Sidebar, MobileNav } from "@/components/Sidebar";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Scanner from "@/pages/Scanner";
import Schedules from "@/pages/Schedules";
import Cases from "@/pages/Cases";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Mentions from "@/pages/Mentions";
import CheckUrl from "@/pages/CheckUrl";
import Medien from "@/pages/Medien";

function AppShell() {
  return (
    <div className="flex min-h-screen bg-[#FAF7F2] text-[#0A0A0A] selection:bg-[#E5E1DB]">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <MobileNav />
        <main className="flex-1 overflow-x-hidden">
          <div className="mx-auto w-full max-w-7xl p-4 sm:p-5 md:p-8 lg:p-10">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF7F2] text-sm text-[#8B8A8E]">
        Lädt …
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireAuth><AppShell /></RequireAuth>}>
            <Route path="/" element={<Overview />} />
            <Route path="/scanner" element={<Scanner />} />
            <Route path="/pruefen" element={<CheckUrl />} />
            <Route path="/medien" element={<Medien />} />
            <Route path="/zeitplan" element={<Schedules />} />
            <Route path="/fallakte" element={<Cases />} />
            <Route path="/erwaehnungen" element={<Mentions />} />
            <Route path="/einstellungen" element={<Settings />} />
            <Route path="/benutzer" element={<Users />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
